var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpravljanjeMedjunarodnimKonvencijama(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_1252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 16.001C31 24.285 24.284 31.001 16 31.001C7.716 31.001 1 24.285 1 16.001M31 16.001C31 7.717 24.284 1.001 16 1.001C7.716 1.001 1 7.717 1 16.001M31 16.001H1M11.834 1.5879C9.397 5.8329 8.004 10.7549 8.004 16.0009C8.004 21.2469 9.396 26.1689 11.834 30.4139M20.1699 30.4121C22.6079 26.1681 23.9999 21.2471 23.9999 16.0011C23.9999 10.7571 22.6069 5.8381 20.1719 1.5901M27.6543 25.4395C24.0883 23.8745 20.1473 23.0045 16.0043 23.0045C11.8573 23.0045 7.9143 23.8765 4.3453 25.4435M4.3486 6.5635C7.9146 8.1315 11.8576 9.0015 16.0036 9.0015C20.1486 9.0015 24.0896 8.1305 27.6586 6.5635M15.999 1V31",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_1252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23, 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.010) translate(-960, -960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1703.534 960c0-41.788-3.84-84.48-11.633-127.172l210.184-182.174-199.454-340.856-265.186 88.433c-66.974-55.567-143.323-99.389-223.85-128.415L1158.932 0h-397.78L706.49 269.704c-81.43 29.138-156.423 72.282-223.962 128.414l-265.073-88.32L18 650.654l210.184 182.174C220.39 875.52 216.55 918.212 216.55 960s3.84 84.48 11.633 127.172L18 1269.346l199.454 340.856 265.186-88.433c66.974 55.567 143.322 99.389 223.85 128.415L761.152 1920h397.779l54.663-269.704c81.318-29.138 156.424-72.282 223.963-128.414l265.073 88.433 199.454-340.856-210.184-182.174c7.793-42.805 11.633-85.497 11.633-127.285m-743.492 395.294c-217.976 0-395.294-177.318-395.294-395.294 0-217.976 177.318-395.294 395.294-395.294 217.977 0 395.294 177.318 395.294 395.294 0 217.976-177.317 395.294-395.294 395.294",
    fill: "black",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpravljanjeMedjunarodnimKonvencijama);
export default __webpack_public_path__ + "static/media/UpravljanjeMedjunarodnimKonvencijama.92bd76887f311320a6d0699602e3aece.svg";
export { ForwardRef as ReactComponent };